export const sizeOfAnObjectInMb = (object: {}) => {
  if (Object.keys(object).length === 0) return 0;
  const sizeInBytes = JSON.stringify(object).replace(/[",[\]]/g, '');
  return sizeInBytes.length / 1048576;
};
